<template>
  <div>
    <ui-modal
      ref="modal"
      :title="`Información Bookings por Confirmar - Cliente - ${clienteModel} Nro Booking: ${nroBookingModel}`"
      @close="actionSetVisibleModalInformacionGeneral(false), ActionSetZindexTablaModal(false);"
      size="large"
    >
      <div v-if="load">
        <Loading />
      </div>
      <ui-tabs v-else fullwidth raised disableRipple>

        <!-- TAB 1 -->
        <ui-tab key="informacion_prueba_2" title="Información General">

          <!-- Primera Fila -->
          <div class="d-flex">

            <!-- Cliente -->
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Cliente</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2" v-text="clienteModel"></p>
              </div>
            </div>

            <!-- Shipper -->
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Shipper</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2" v-text="shipperModel"></p>
              </div>
            </div>
            
            <!-- POL -->
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">POL</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">{{ polModel ? polModel : "Sin definir" }}</p>
              </div>
            </div>

            <!-- POD -->
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">POD</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2" v-text="podModel"></p>
              </div>
            </div>

            <!-- Destino Final -->
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Destino Final</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ destinoModel ? destinoModel : "Sin definir" }}
                </p>
              </div>
            </div>

          </div>

          <!-- Segunda Fila -->
          <div class="d-flex">

            <!-- POL ETD -->
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">POL ETD</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ polETDModel ? polETDModel : "Sin definir" }}
                </p>
              </div>
            </div>

            <!-- POD ETA -->
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">POD ETA</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ polETAModel ? polETAModel : "Sin definir" }}
                </p>
              </div>
            </div>

            <!-- Transbordo -->
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Transbordo</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ transbordoModel ? transbordoModel : "Sin definir" }}
                </p>
              </div>
            </div>

          </div>

          <!-- Tercera Fila -->
          <div class="d-flex">

            <!-- Stacking From -->
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Stacking From</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ stackingFROMModel ? stackingFROMModel : "Sin definir" }}
                </p>
              </div>
            </div>

             <!-- Stacking To -->
             <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Stacking To</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ stackingTOModel ? stackingTOModel : "Sin definir" }}
                </p>
              </div>
            </div>
            <!-- Corte Documental -->
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Corte Documental</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{
                    corteDocumentalModel ? corteDocumentalModel : "Sin definir"
                  }}
                </p>
              </div>
            </div>

            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Corte Documental Anticipado</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ corteDocumentalAnticipado ? corteDocumentalAnticipado : "Sin definir" }}
                </p>
              </div>
            </div>

          </div>

          <!-- Cuarta Fila-->
          <div class="d-flex">

            <!-- Cantidad -->
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Cantidad</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2" v-text="cantidadModel"></p>
              </div>
            </div>

            <!-- Producto -->
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Producto</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2" v-text="productoModel"></p>
              </div>
            </div>

            <!-- Equipo -->
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Equipo</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ equipoModel ? equipoModel : "Sin definir" }}
                </p>
              </div>
            </div>

            <!-- Temperatura -->
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Temperatura</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ temperaturaModel ? "°" + temperaturaModel : "Sin definir" }}
                </p>
              </div>
            </div>

            <!-- Ventilación % -->
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Ventilación %</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ ventilacionModel ? ventilacionModel : "Sin definir" }}
                </p>
              </div>
            </div>

            <!-- Ventilación CBM -->
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Ventilación CBM</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{
                    ventilacionCBMModel ? ventilacionCBMModel : "Sin definir"
                  }}
                </p>
              </div>
            </div>

          </div>

          <!-- Quinta Fila -->
          <div class="d-flex">

            <!-- Tipo Pago -->
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Tipo Pago</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">{{ pagoModel ? pagoModel : "Sin definir" }}</p>
              </div>
            </div>

            <!-- Genset -->
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Genset</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ gensetModel ? gensetModel : "Sin definir" }}
                </p>
              </div>
            </div>

            <!-- Cold Treatment -->
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Cold Treatment</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ coldTreatmentModel ? coldTreatmentModel : "Sin definir" }}
                </p>
              </div>
            </div>

            <!-- Depósito -->
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Depósito</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ depositoModel ? depositoModel : "Sin definir" }}
                </p>
              </div>
            </div>

            <!-- Consignatario -->
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Consignatario</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2" v-text="consignatarioModel"></p>
              </div>
            </div>

            <!-- Notificado -->
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Notificado</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ notificadoModel ? notificadoModel : "Sin definir" }}
                </p>
              </div>
            </div>

          </div>

          <!-- Sexta Fila -->
          <div class="d-flex">

            <div class="w-50">

              <!-- Número de contrato -->
              <div class="Heading Cell"><p class="m-2">Número de contrato</p></div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">{{ contratoModel ? contratoModel : "Sin definir" }}</p>
              </div>

            </div>

            <div class="w-50">

              <!-- Emisión BL -->
              <div class="Heading Cell"><p class="m-2">Emisión BL</p></div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">{{ bLModel ? bLModel : "Sin definir" }}</p>
              </div>

            </div>

          </div>

          <!-- Septima Fila -->
          <div class="d-flex">

            <div class="w-100">
              <div class="Heading Cell">
                <p class="m-2">Comentarios</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ comentarioModel ? comentarioModel : "Sin definir" }}
                </p>
              </div>
            </div>

          </div>

        </ui-tab>
        <!-- TAB 2 -->
        <ui-tab
          key="historial"
          :title="`Historial de Booking ID: ${idHistorial}`"
          @select="changeStateHistorialAcciones"
        >
          <div>
            <historial-acciones
              v-if="showHistorialAcciones"
              :cabeceras="headers"
              :id="dataDetalle"
              :constant="constante"
            />
          </div>
        </ui-tab>
      </ui-tabs>
    </ui-modal>
  </div>
</template>

<script>
// UI Modal
import UiModal from "keen-ui/src/UiModal";
import UiTabs from "keen-ui/src/UiTabs";
import UiTab from "keen-ui/src/UiTab";
// Common
import HistorialAcciones from "../../../../common/HistorialAcciones";
// Vuex
import { mapState, mapActions } from "vuex";
// Constantes
import { getHistorialBookingPorConfirmar } from "../../../../../constants/lineas";
import Loading from "../../../../common/loading.vue";

export default {
  props: ["data", "dataVer", "load"],
  data() {
    return {
      constante: getHistorialBookingPorConfirmar,
      idBookingModel: "",
      clienteModel: "",
      shipperModel: "",
      polModel: "",
      podModel: "",
      destinoModel: "",
      polETDModel: "",
      polETAModel: "",
      transbordoModel: "",
      stackingFROMModel: "",
      stackingTOModel: "",
      corteDocumentalModel: "",
      corteDocumentalAnticipado: "",
      cantidadModel: "",
      productoModel: "",
      equipoModel: "",
      temperaturaModel: "",
      ventilacionModel: "",
      ventilacionCBMModel: "",
      pagoModel: "",
      gensetModel: "",
      coldTreatmentModel: "",
      depositoModel: "",
      consignatarioModel: "",
      notificadoModel: "",
      contratoModel: "",
      bLModel: "",
      comentarioModel: "",

      dataDetalle: "",
      idHistorial: "",
      headers: ["Usuario", "Fecha", "Acción"],
      showHistorialAcciones: false,

      nroBookingModel: "",
    };
  },
  components: {
    UiModal,
    HistorialAcciones,
    UiTabs,
    UiTab,
    Loading,
  },
  computed: {
    ...mapState("lineas", ["visibleModalInformacionGeneral"]),
  },
  methods: {
    ...mapActions("lineas", [
      "actionSetVisibleModalInformacionGeneral",
    ]),
    ...mapActions(["ActionSetZindexTablaModal"]),

    changeStateHistorialAcciones() {
      this.showHistorialAcciones = true;
    },
    openModal(ref) {
      this.$refs[ref].open();
    },

    closeModal(ref) {
      this.$refs[ref].close();
    },
  },
  watch: {
    visibleModalInformacionGeneral: function (_new) {
      _new && this.openModal("modal");
      _new && this.ActionSetZindexTablaModal(true);
    },
    data: function (_new) {
      this.dataDetalle = _new.data_complementaria.booking_id;

      this.idBookingModel = _new.data[0];
      this.clienteModel = _new.data[2];
      this.shipperModel = _new.data[3];
      this.podModel = _new.data[7];
      this.cantidadModel = _new.data[8];
      this.productoModel = _new.data[9];
      this.consignatarioModel = _new.data[6];
      this.idHistorial = _new.data[0];
    },
    dataVer: function (_new) {
      this.polModel = _new.pol;
      this.destinoModel = _new.destino_final;
      this.polETDModel = _new.pol_etd;
      this.polETAModel = _new.pod_eta;
      this.transbordoModel = _new.transbordo;
      this.stackingFROMModel = _new.stacking_from;
      this.stackingTOModel = _new.stacking_to;
      this.corteDocumentalModel = _new.corte_documental;
      this.corteDocumentalAnticipado = _new.corte_documental_anticipado;
      this.equipoModel = _new.equipo;
      this.temperaturaModel = _new.temperatura;
      this.ventilacionModel = _new.ventilacion;
      this.ventilacionCBMModel = _new.ventilacion_cbm;
      this.pagoModel = _new.flete;
      this.gensetModel = _new.genset;
      this.coldTreatmentModel = _new.cold_treatment;
      this.depositoModel = _new.deposito;
      this.notificadoModel = _new.notificado;
      
      if (_new.contrato !== null) {
        this.contratoModel = _new.contrato;
      } else {

        if ( _new.contrato_booking_itineraries.length ) {
          this.contratoModel = 'Otros - ' + _new.contrato_booking_itineraries;
        } else {
          this.contratoModel = 'Otros - ' + _new.contrato_booking;
        }
        
      }

      this.bLModel = _new.emision_bl;
      this.comentarioModel = _new.comentarios;
    },
  },
};
</script>
<style>
.modal-informacion-por-confirmar .ui-modal__container {
  width: 80% !important;
  margin-top: 60px !important;
}
.Heading {
  background-color: #ccccca;
  font-weight: bold;
  text-align: center;
}

.Cell {
  border: groove;
  border-width: thin;
}
</style>
